module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_a/main_pc_74d9ba8b55200192eb804419f7b902c4.jpg";